import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import './FAQSection.css';

const FAQSection = ({ faqs }) => {
  return (
    <div className="faq-container">
      <Accordion type="single" collapsible className="faq-accordion">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`} className="faq-item">
            <AccordionTrigger className="faq-question">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="faq-answer">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQSection;
